import styled from "styled-components";
import {Card, InputNumber} from "antd";

export const Container = styled(Card)`
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.05), 0 6px 6px rgba(0,0,0,0.08);
    margin-top: 8px;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 12px;
    padding-bottom: 8px;
    min-height: 132px;
    max-height: 132px;
`;

export const TextContainer = styled.div``;

export const Title = styled.p`
    color: #283f6d;
    font-weight: bold;
    font-size: 32px;
`;
export const Value = styled.p`
    color: ${props => props.color};
    font-size: 12px;
`;
export const Text = styled.p`
    font-size: 14px;
`;
export const IconContainer = styled.div`
    font-size: 32px;
    color: ${props => props.color};
`;

export const NoIcon = styled.div`
    width: 32px;
    padding: 24px;
    height: 32px;
`;

export const SpinnerContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;
export const ButtonContainer = styled.div`
    margin-left: 16px;
`;

export const ProgressContainer = styled.div`
    display: block;
    width: 80%;
    margin-bottom: 32px;
    position: absolute;
`;

export const ProgressText = styled.text`
    font-size: 12px;
`;

export const NumberInput = styled(InputNumber)`
    .ant-input-number-handler-wrap {
        visibility: hidden;
    }
`;
